import { render } from "./CommonFooter.vue?vue&type=template&id=ae556e42&scoped=true"
const script = {}

import "./CommonFooter.vue?vue&type=style&index=0&id=ae556e42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae556e42"]])

export default __exports__